import bridalLove from "../img/buchete-mireasa/bridal-love.webp";
import memory from "../img/buchete-mireasa/memory.webp";
import peony from "../img/buchete-mireasa/peony.webp";
import colorMix from "../img/buchete-mireasa/colorMix.webp";
import rose from "../img/buchete-mireasa/rose.webp";
import hortensiaLove from "../img/buchete-mireasa/hortensiaLove.webp";
import romanticLove from "../img/buchete-mireasa/romantic-Love.webp";
import simplicity from "../img/buchete-mireasa/simplicity.webp";
import classicRose from "../img/buchete-mireasa/classic-rose.webp";
import pastelRomance from "../img/buchete-mireasa/pastel-romance.webp";
import flowerCrown from "../img/buchete-mireasa/flower-crown.webp";
import bridalAccessories from "../img/buchete-mireasa/bridal-accessories.webp";

const bucheteMireasa = [
  {
    id: 19,
    name: "Bridal Love",
    price: "1800 lei",
    description:
      "Buchet elegant compus din hortensie, dianthus, hypericum, eustome și eucalipt. ",
    images: [bridalLove],
  },
  {
    id: 20,
    name: "Memory",
    price: "1400 lei",
    description: "Buchet format dintr-un mix de trandafiri și eucalipt. ",
    images: [memory],
  },
  {
    id: 21,
    name: "Peony",
    price: "3400 lei",
    description: "Buchet format din bujori albi mixați cu eucalipt.",
    images: [peony],
    // checkAvailability: true,
  },

  {
    id: 22,
    name: "Color Mix",
    price: "2500 lei",
    description: "Buchet superb din hortensie, bujori, frezii si azothamus.",
    images: [colorMix],
    // checkAvailability: true,
  },
  {
    id: 23,
    name: "Rose",
    price: "1500 lei",
    description: "Buchet format din trandafiri, eucalipt și gipsofila albă.",
    images: [rose],
  },
  {
    id: 24,
    name: "Hortensia Love",
    price: "1400 lei",
    description: "Buchet elegant din hortensie și gipsofila.",
    images: [hortensiaLove],
  },
  {
    id: 25,
    name: "Romantic Love",
    price: "1500 lei",
    description:
      "Buchet elegant format din trandafiri roz , eustome albe și eucalipt .",
    images: [romanticLove],
  },
  {
    id: 26,
    name: "Simplicity",
    price: "900 lei",
    description:
      "Buchet elegant format din trandafiri roz, eustome albe și eucalipt.",
    images: [simplicity],
  },
  {
    id: 27,
    name: "Classic Rose",
    price: "950 lei",
    description:
      "Buchet elegant format din trandafiri albi, eustome roz și eucalipt.",
    images: [classicRose],
  },
  {
    id: 28,
    name: " Pastel Romance",
    price: "1900 lei",
    description:
      "Buchet elegant format din trandafiri albi, fresii albe, gipsofila alba și eucalipt.",
    images: [pastelRomance],
  },
  {
    id: 29,
    name: "Bridal Crown",
    price: "750 lei",
    description: "Coronita de mireasa formata din gipsofila alba.",
    images: [flowerCrown],
  },
  {
    id: 30,
    name: "Bridal Accessories",
    price: "150 lei",
    description:
      "O butoniera pentru mire si oaspeti format din trandafiri, eustome si eucalipt.",
    images: [bridalAccessories],
  },
];

export default bucheteMireasa;
